const ProductSection = () => {
  return (
    <div className="flex flex-col items-center min-h-50vh gap-2">
      <hr className="react-reveal hr" />

      <div className="max-w-6xl w-full p-8">
        <div className="grid md:grid-cols-2 gap-8 relative">
          {/* Left Card - Sentiments Express */}
          <div className="text-left sm:text-right px-6">
            <img
              src="/Home/sentiments.svg"
              alt="Sentiments Express Logo"
              className="sm:ml-auto mb-7 h-14"
            />
            <h2 className="font-bold text-sm mb-4 tracking-wide">
              Pakistan's First Gifting Platform – Spreading Joy Since 1989
            </h2>
            <div className="  space-y-4 text-sm text-gray-700 leading-relaxed">
              <p>
                Founded in 1989, TCS Sentiments Express has set the benchmark
                for online gifting in Pakistan. The platform offers a wide range
                of thoughtfully curated gifts — including fresh flowers, cakes,
                mithai, fruit baskets, chocolates, and personalized hampers —
                suitable for every occasion, from birthdays and weddings to
                corporate milestones.
              </p>
              <p>
                Deliveries are fulfilled across Pakistan and internationally,
                with service to destinations such as the UK, USA, UAE, and
                Germany. Backed by TCS's logistics expertise, each gift is
                packaged with care and delivered with precision.
              </p>
            </div>
            <button
              onClick={() =>
                window.open("https://sentimentsexpress.com/", "_blank")
              }
              className="bg-[#E31566] hover:bg-pink-700 text-white font-bold py-3 px-8 text-xs tracking-wider mt-6"
            >
              GIFT NOW
            </button>
          </div>

          {/* Vertical Divider */}
          <div className="absolute left-1/2 top-8 bottom-20 w-[2px] bg-red-500 transform -translate-x-1/2 hidden md:block"></div>

          {/* Right Card - Studio by TCS */}
          <div className="text-left px-6  flex flex-col h-full ">
            <img
              src="/home/studio.svg"
              alt="Studio by TCS Logo"
              className="mr-auto mb-7 h-14"
            />
            <h2 className="font-bold text-sm mb-4 tracking-wide">
              Studio by TCS - We Deliver Fashion
            </h2>
            <div className="  space-y-4 text-sm text-gray-700 leading-relaxed">
              <p>
                Studio by TCS brings curated collections from top Pakistani
                designers straight to your doorstep. From bridal looks to
                everyday elegance, we deliver fashion across the globe —
                including London, New York, Houston, and Dubai.
              </p>
              <p>
                With TCS's trusted logistics, shopping your favorite
                embroideries, fabrics, and silhouettes is seamless, wherever you
                are.
              </p>
            </div>
            <button
              onClick={() =>
                window.open("https://www.studiobytcs.com/", "_blank")
              }
              className="bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 text-xs tracking-wider md:mt-auto self-start mt-6"
            >
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSection;
